let sessionExpiredHandled = false;

export async function authFetch(
  url: string,
  options: RequestInit = {},
): Promise<Response> {
  if (!url || url === "undefined" || url.includes("undefined")) {
    return Promise.reject(new Error("Invalid URL"));
  }

  const token = localStorage.getItem("authToken");

  const makeRequest = async (authToken: string | null) => {
    const headers: Record<string, string> = {
      ...((options.headers as Record<string, string>) || {}),
      ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}),
    };

    return fetch(url, {
      ...options,
      headers,
    });
  };

  const response = await makeRequest(token);


  if (response.status === 401) {
    let message = "Session expired, please login again";

    try {
      const errorData = await response.json();
      message = errorData?.message || message;
    } catch (e) {}

    if (!sessionExpiredHandled) {
      sessionExpiredHandled = true;

      alert(message);

      localStorage.removeItem("authToken");

      window.location.href = "/";
    }

    throw new Error(message);
  }


  if (response.ok) {
    sessionExpiredHandled = false;
  }

  
  if (!response.ok) {
    let errorMessage = "Something went wrong";

    try {
      const errorData = await response.text();
      errorMessage = errorData;
    } catch (e) {}

    throw new Error(errorMessage);
  }

  return response;
}
